import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { SchirmerTearTestLeftEyeAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-schirmer-tear-test-left-eye-slot',
    templateUrl: './schirmer-tear-test-left-eye-slot.component.html',
    styleUrl: './schirmer-tear-test-left-eye-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SchirmerTearTestLeftEyeSlotComponent implements SheetSlotComponentBase {

	action!: SchirmerTearTestLeftEyeAction;
	value!: string | null;

	@Input('action') set updateAction(action: SchirmerTearTestLeftEyeAction | null) {
		this.action = action as SchirmerTearTestLeftEyeAction;
		this.value = this.action.eye?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}